import React from "react"

export default function Modal({
  children,
  open,
  primaryButton: { text: primaryText, action: primaryAction, disabled: primaryDisabled },
  secondaryButton,
  leftButton: { text: leftText, action: leftAction, disabled: leftDisabled },
  close,
}) {
  if (!open) return null

  const onKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Escape") {
      close && close()
    }
  }

  return (
    <div
      className="relative z-10 text-base font-sans font-normal"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
      onKeyDown={(e) => onKeyDown(e)}
    >
      <div className="fixed inset-0 bg-black bg-opacity-25 dark:bg-opacity-75 transition-opacity">
        <div className="flex flex-col items-stretch justify-center p-4 mx-auto md:my-36 max-w-lg relative transform rounded-lg ">
          <div className="bg-white dark:bg-gray-700 dark:text-gray-50 px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
            {children}
          </div>
          <div className="bg-gray-50 dark:bg-gray-800 px-4 py-3 flex flex-col md:flex-row justify-between items-center sm:px-6">
            {leftText && (
              <button
                type="button"
                className="text-xs text-gray-900 dark:text-gray-100"
                onClick={() => leftAction()}
                disabled={leftDisabled}
              >
                {leftText}
              </button>
            )}
            <div className="mt-3 md:mt-0 flex flex-row-reverse items-center gap-2">
              <button
                type="button"
                className="inline-flex xw-full justify-center rounded-md bg-sky-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-sky-500 disabled:bg-sky-100 disabled:text-gray-500"
                onClick={() => primaryAction()}
                disabled={primaryDisabled}
                data-testid="modal-primary-button"
              >
                {primaryText}
              </button>
              {secondaryButton && (
                <button
                  type="button"
                  className="inline-flex xw-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:bg-sky-100 disabled:text-gray-500"
                  onClick={() => secondaryButton.action()}
                  disabled={secondaryButton.disabled}
                  data-testid="modal-secondary-button"
                >
                  {secondaryButton.text}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
